import { render, staticRenderFns } from "./FeedbackActions.vue?vue&type=template&id=7221ffce&lang=pug&"
import script from "./FeedbackActions.vue?vue&type=script&lang=js&"
export * from "./FeedbackActions.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports